export default __webpack_public_path__ + "images/4_thumbnail.jpg";